import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { createErrorFallback } from '@/fragments/create-error-fallback'
import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { manualQuotesQueryOptions } from './api/useManualQuotes'
import { QuotesLayout } from './view/quotesLayout'

export const quotesSearchSchema = z.object({
  filter: z
    .object({
      quotesType: z
        .string()
        .nullish()
        .transform((data) => data ?? undefined),
    })
    .nullish()
    .transform((data) => data ?? undefined),
})

export const quotesRoute = createRoute({
  getParentRoute: () => quotesLayoutRoute,
  path: '/quotes',
  errorComponent: createErrorFallback('An error occurred while loading manual quotes'),
  loader: ({ context }) => context?.queryClient?.ensureQueryData(manualQuotesQueryOptions()),
}).lazy(() => import('./quotes').then((d) => d.Route))

export const quotesLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'quotes-layout',
  component: QuotesLayout,
  validateSearch: quotesSearchSchema,
  beforeLoad: ensureAuthenticatedUser,
})
